import { render, staticRenderFns } from "./AreaInfoForm.vue?vue&type=template&id=abb8eab4&scoped=true&"
import script from "./AreaInfoForm.vue?vue&type=script&lang=ts&"
export * from "./AreaInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./AreaInfoForm.vue?vue&type=style&index=0&id=abb8eab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb8eab4",
  null
  
)

export default component.exports